module.exports = __webpack_public_path__ + "img/Kerze_Creme.34cb0bdf.png";